import Endpoints from '../endpoints';
import axios from '../api';
import ErrorMessages from '../../shared/ErrorMessages';
import { stringifyFilters } from '../../shared/utility';
import { Creators as UsersCreators } from './user';

export const actionTypes = {
  GET_PARTNERS: 'partners/GET_ALL',
  GET_PARTNERS_SUCCESS: 'partners/GET_ALL_SUCCESS',
  GET_PARTNERS_ERROR: 'partners/GET_ALL_ERROR',
  RESET: 'partners/RESET',
}

const initialState = {
  loading: false,
  error: null,
  data: {},
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.GET_PARTNERS:
      return { ...state, loading: true };
    case actionTypes.GET_PARTNERS_SUCCESS:
      return { 
        ...state, 
        loading: false, 
        data: action.payload.data, 
      };
    case actionTypes.GET_PARTNERS_ERROR:
      return { ...state, loading: false, error: action.payload.error };
    case actionTypes.RESET:
      return { ...state, ...initialState };
    default:
      return state;
  }
}

export const Creators = {
  getPartnerUsers: (filter) => async dispatch => {
    dispatch({ type: actionTypes.GET_PARTNERS });
    try {
      filter = filter ?? {};
      const filter_str = stringifyFilters(filter);
      const { data } = await axios.get(`${Endpoints.users}${filter_str}`);
      dispatch({
        type: actionTypes.GET_PARTNERS_SUCCESS,
        payload: { data: data }
      });
    } catch (err) {
      const { response } = err;
      if (response?.status === 404) {
        dispatch({
          type: actionTypes.GET_PARTNERS_ERROR,
          payload: { error: 'Não foi possível buscar os usuarios no momento' }
        });
      } else if (response?.status === 403 && response?.data?.detail) {
        dispatch({
          type: actionTypes.GET_PARTNERS_ERROR,
          payload: { error: response?.data?.detail },
        });
      } else if (response?.status === 401) {
        UsersCreators.logoutAndRedirect();
        dispatch({
          type: actionTypes.GET_PARTNERS_ERROR,
          payload: { error: ErrorMessages.defaultCredentialsError },
        });
      } else {
        dispatch({
          type: actionTypes.GET_PARTNERS_ERROR,
          payload: { error: ErrorMessages.serviceUnavailable },
        });
      }
    }
  },
  getPartnerUser: async (id) => {
    try {
      const { data } = await axios.get(`${Endpoints.users}/${id}`);
      return { data };
    } catch (err) {
      if (err?.response?.data) {
        return { error: err.response.data };
      }
      return { error: 'Ocorreu um erro ao tentar obter o usuário. Por favor, tente novamente' };
    }
  },
  createPartnerUser: async (fields) => {
    try {
      const { data } = await axios.post(Endpoints.users, fields);
      return { data };
    } catch (err) {
      if (err?.response?.data) {
        return { error: err.response.data };
      }
      return { error: 'Ocorreu um erro ao tentar criar o usuário. Por favor, tente novamente' };
    }
  },
  resetPassword: async (id) => {
    return await UsersCreators.resetPasswordForUser(id);
  },
  updatePartnerUser: async (partnersId, fields) => {
    try {
      const { data } = await axios.put(`${Endpoints.users}/${partnersId}`, fields);
      return { data };
    } catch (err) {
      if (err?.response?.data) {
        return { error: err.response.data };
      }
      return { error: 'Ocorreu um erro ao tentar atualizar o usuário. Por favor, tente novamente' };
    }
  },
  deletePartnerUser: async (partnersId) => {
    try {
      const { data } = await axios.delete(`${Endpoints.users}/${partnersId}`);
      return { data };
    } catch (err) {
      return { error: 'Ocorreu um erro ao tentar deletar o usuário. Por favor, tente novamente' };
    }
  },
  restorePartnerUser: async (partnersId) => {
    try {
      const { data } = await axios.post(`${Endpoints.users}/${partnersId}/restore`);
      return { data };
    } catch (err) {
      return { error: 'Ocorreu um erro ao tentar restaurar o usuário. Por favor, tente novamente' };
    }
  },
  resetPartnerUsers: () => ({ type: actionTypes.RESET })
};